/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:56e8b768-9f24-457b-bf33-7e9bd00bb01b",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_Q3muRHVGl",
    "aws_user_pools_web_client_id": "2rbd2rsf72rf3eg6do5qo29jhq",
    "oauth": {
        "domain": "fitprintapif00af6e9-f00af6e9-prod.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://admin.fitprint.io/",
        "redirectSignOut": "https://admin.fitprint.io/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "FitPrintAPI",
            "endpoint": "https://scaysscz24.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "userTable-prod",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "fitprintapic3fb212387df4b2a80f7ea6fd02e165971540-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
